import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShoppingBag, FiPackage, FiCoffee } = FiIcons;

const Menu = () => {
  const categories = [
    {
      icon: FiShoppingBag,
      title: 'Fresh Halal Meat',
      items: [
        'Lamb Shawarma - Delicious and affordable',
        'Fresh Beef - Excellent quality with great value',
        'Chicken - Premium halal chicken',
        'Goat Meat - Traditional cuts available',
        'Ground Meat - Freshly prepared daily'
      ]
    },
    {
      icon: FiPackage,
      title: 'Asian Groceries',
      items: [
        'Basmati Rice - Premium quality',
        'Spices & Seasonings - Authentic flavors',
        'Lentils & Pulses - Fresh stock',
        'Cooking Oils - Various types available',
        'Frozen Foods - Wide selection'
      ]
    },
    {
      icon: FiCoffee,
      title: 'Mediterranean Products',
      items: [
        'Olive Oil - Extra virgin quality',
        'Olives - Various types and sizes',
        'Cheese - Fresh Mediterranean varieties',
        'Herbs - Fresh and dried options',
        'Bread - Freshly baked daily'
      ]
    }
  ];

  const images = [
    'https://i.ibb.co/PsDpdSn1/Gateshead-Halal-Food-Store-image-19.jpg',
    'https://i.ibb.co/Y79tTvCx/Gateshead-Halal-Food-Store-image-21.jpg',
    'https://i.ibb.co/7dQ1ctKk/Gateshead-Halal-Food-Store-image-23.jpg',
    'https://i.ibb.co/bMPsMFzg/Gateshead-Halal-Food-Store-image-25.jpg'
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="min-h-screen py-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div variants={itemVariants} className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-secondary-600 via-primary-600 to-accent-600 bg-clip-text text-transparent mb-4">
            Our Products
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our wide range of fresh halal meat, Asian groceries, and Mediterranean products.
          </p>
        </motion.div>

        {/* Product Images */}
        <motion.div variants={itemVariants} className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {images.map((image, index) => (
            <motion.img
              key={index}
              src={image}
              alt={`Product ${index + 1}`}
              className="rounded-lg shadow-lg w-full h-48 object-cover border-2 border-primary-200"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            />
          ))}
        </motion.div>

        {/* Product Categories */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow border border-primary-200"
              whileHover={{ y: -5 }}
            >
              <div className="w-16 h-16 bg-gradient-to-br from-secondary-100 via-primary-100 to-accent-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={category.icon} className="h-8 w-8 text-primary-600" />
              </div>
              <h2 className="text-2xl font-bold bg-gradient-to-r from-secondary-600 to-primary-600 bg-clip-text text-transparent text-center mb-6">
                {category.title}
              </h2>
              <ul className="space-y-3">
                {category.items.map((item, itemIndex) => (
                  <motion.li
                    key={itemIndex}
                    className="text-gray-700 border-b border-primary-100 pb-2"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.5 + itemIndex * 0.1 }}
                  >
                    {item}
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Special Offers */}
        <motion.div 
          variants={itemVariants}
          className="mt-16 bg-gradient-to-r from-secondary-600 via-primary-600 to-accent-600 rounded-lg p-8 text-white text-center"
        >
          <h2 className="text-3xl font-bold mb-4">Special Offers</h2>
          <p className="text-xl mb-6">
            Visit us today for the best deals on fresh halal meat and groceries!
          </p>
          <a
            href="tel:+447460008191"
            className="bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors inline-block shadow-lg"
          >
            Call for Current Offers
          </a>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Menu;